import React from "react";

import { ComboBox, Item } from "@react-spectrum/combobox";

import { Provider } from "@react-spectrum/provider";

import { theme } from "@react-spectrum/theme-default";

interface Props {
  options: Iterable<object>;
  placeHolder: string;
  onSelectionChange: (id: number) => void;
  label: string;
}

const Combobox = (props: Props) => {
  const { options, placeHolder, onSelectionChange, label } = props;

  return (
    <>
      <Provider theme={theme} colorScheme="light">
        <div style={{ background: "white" }}>
          <ComboBox
            label={label}
            defaultItems={options}
            onSelectionChange={onSelectionChange}
            placeholder={placeHolder}
          >
            {(item: { id: string; name: string }) => (
              <Item key={item.id}>{item.name}</Item>
            )}
          </ComboBox>
        </div>
      </Provider>
    </>
  );
};

export default Combobox;
try {
    // @ts-ignore
    Combobox.displayName = "Combobox";
    // @ts-ignore
    Combobox.__docgenInfo = { "description": "", "displayName": "Combobox", "props": { "options": { "defaultValue": null, "description": "", "name": "options", "required": true, "type": { "name": "Iterable<object>" } }, "placeHolder": { "defaultValue": null, "description": "", "name": "placeHolder", "required": true, "type": { "name": "string" } }, "onSelectionChange": { "defaultValue": null, "description": "", "name": "onSelectionChange", "required": true, "type": { "name": "(id: number) => void" } }, "label": { "defaultValue": null, "description": "", "name": "label", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Combobox/Combobox.tsx#Combobox"] = { docgenInfo: Combobox.__docgenInfo, name: "Combobox", path: "src/shared/components/Combobox/Combobox.tsx#Combobox" };
}
catch (__react_docgen_typescript_loader_error) { }